module.exports = __webpack_public_path__ + "img/four2Orange.8f05336a.jpg";